export default {"src":"/_next/static/media/phone-flawless.a325862c.svg","height":75,"width":66};